import { render, staticRenderFns } from "./ParticipantCard.vue?vue&type=template&id=b2bf215e"
import script from "./ParticipantCard.vue?vue&type=script&lang=ts"
export * from "./ParticipantCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports